module.exports = __webpack_public_path__ + "static/media/wearable.4d98c8cd.png";